import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* getUsers<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const params = action.payload

        const resp = yield call(CallApi.GET, APIS.USERS.GET_USERS, params)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to fetch users',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getUsers', action: action?.type })
    }
}

export function* deleteUser<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.DELETE, APIS.USERS.DELETE_USERS(action.payload), {})
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to delete user',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'deleteUser', action: action?.type })
    }
}

export function* updateUser<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.PUT, APIS.USERS.UPDATE_USER(action.payload.user_literal), action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to update user',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'updateUser', action: action?.type })
    }
}

export function* updateUserAction<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.USERS.USER_ACTIONS, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to perform user action',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'updateUserAction', action: action?.type })
    }
}
